import s from "./Temoignage.module.scss";


const Temoignage = () => {

    /* Base de données des témoignages */
    const temoignages = [
        {
            person: "Louise, 69 ans",
            quote: "Quand ma vue s’est dégradée, la peur s’est doucement installée. Sortir de chez moi est devenu une épreuve redoutable. Ce n’était pas seulement la peur de trébucher ou de me perdre dans la ville : c’était aussi la peur du regard des autres, la sensation d’être vulnérable, invisible ou au contraire trop remarquée.",
            linkAVH:"A l’approche des fêtes de fin d’année, les personnes aveugles ou malvoyantes ont plus que jamais besoin de préserver des liens sociaux et de pouvoir se déplacer en toute autonomie pour faire leurs achats, aller voir leurs proches et partager avec eux des moments conviviaux comme tout un chacun."
        }
    ]

    /* Sélectionne un témoignage au hasard */
    const randomIndex = Math.floor(Math.random() * temoignages.length);
    const selectedTemoignage = temoignages[randomIndex];
    


    return (
        <section className={s.temoignage}>
            <div className={s.temoignage__content}>
                <div className={s.temoignage__text}>
                    <p className={s.quote}>{selectedTemoignage.quote}</p>
                    <p className={s.person}>{selectedTemoignage.person}</p>
                    {selectedTemoignage.stars && <p className={s.stars}>{selectedTemoignage.stars}</p>}
                </div>
            </div>
            <div className={s.temoignage__linkAVH}>
                <p>{selectedTemoignage.linkAVH}</p>
            </div>
        </section>
    )
}

export default Temoignage;